/**
 * HomeStats — numbers strip directly under the hero.
 *
 * Replaces the old hero mockups as the first piece of proof: concrete figures
 * read faster than screenshots and cost nothing in page weight.
 */
import { motion } from "framer-motion";

const stats = [
  { value: "15+", label: "Ganacsi" },
  { value: "17+", label: "Magaalo" },
  { value: "180+", label: "App" },
  { value: "24/7", label: "Taageero" },
];

export default function HomeStats() {
  return (
    <section className="border-y border-border" style={{ background: "var(--bg-muted)" }}>
      <div className="mx-auto max-w-5xl px-6 py-8 sm:py-10">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              className="text-center"
            >
              <p
                className="font-heading text-navy"
                style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", fontWeight: 800, letterSpacing: "-0.03em" }}
              >
                {stat.value}
              </p>
              <p className="mt-1 text-xs font-medium uppercase tracking-wider text-muted sm:text-sm">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
